import {axiosIns} from 'config/api.config'

export const NotificationService = {
  getList: async (payload): Promise<any> => await axiosIns.post('/notification/filter', payload),
  getUnreadCount: async (): Promise<any> => await axiosIns.get('/notification/unread-count'),
  markRead: async (payload: {id: string}): Promise<any> => await axiosIns.post('/notification/mark-read', payload),
  markAllRead: async (): Promise<any> => await axiosIns.post('/notification/mark-all-read', {}),
  dismiss: async (payload: {id: string}): Promise<any> => await axiosIns.delete('/notification/dismiss', {data: payload}),
  getSettings: async (): Promise<any> => await axiosIns.get('/notification/settings'),
  updateSettings: async (payload): Promise<any> => await axiosIns.put('/notification/settings', payload),
}
